<template lang="pug">
  dialogs(:show.sync="visible" :option="{ size: 'lg' }" :title="this.$t('management_page.security_pledge_management')")
    h2 {{$t('management_page.applied_version')}}
    ul.list
      li(@click="openDetail('now')")
        img(src="~@/assets/icon/file.svg" width="36" height="48")
        span {{ versionString }}
    h2 {{$t('management_page.version_management')}}
      b-button(size="sm" variant="primary" @click="detailForm = {}; visibleForm = true;") {{$t('management_page.new_registration')}}
    ul.list
      li(v-for="item of list" @click="openDetail(item)")
        img(src="~@/assets/icon/file.svg" width="36" height="48")
        span {{ item.security_agreement_version }}
        b-button(size="sm" @click.stop="changeVersion(item.security_agreement_version)") {{$t('apply')}}
    .modal-footer
      b-btn(size="sm" @click="visible = false" pill) {{$t('submit')}}

    form-dialog(:show.sync="visibleForm" :form="detailForm" :isAdd="isAdd" @complete="complete")
</template>

<script>
import { SecurityAgreementAPI, CompanyFunctionAPI } from "@/api"
import Dialogs from "@/components/mixins/dialog/index.vue"
import FormDialog from "./form.vue"
import _ from "lodash"

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    version: {
      type: String,
      default: "",
    },
  },
  components: {
    Dialogs,
    FormDialog,
  },
  watch: {
    show(newVal) {
      this.visible = newVal
      if (newVal) {
        this.versionString = this.version
        this.fetchList()
      }
    },
    visible(newVal) {
      this.$emit("update:show", newVal)
    },
  },
  data() {
    return {
      visible: false,
      visibleForm: false,
      versionString: "",
      form: {},
      isAdd: false,
      list: [],
      detailForm: {},
    }
  },
  methods: {
    fetchList() {
      SecurityAgreementAPI.get().then(res => {
        const { data } = res
        this.list = data.objects
      })
    },
    openDetail(item) {
      if (item === "now") {
        item = _.find(this.list, { security_agreement_version: this.versionString })
      }
      this.detailForm = item
      this.visibleForm = true
    },
    changeVersion(version) {
      const params = {
        request_type: "security_agreement_version",
        value: version,
      }
      CompanyFunctionAPI.put("", params).then(res => {
        this.$awn.success(String(this.$t('toasts_message.version_applied')))
        this.versionString = version
        this.$emit("update:version", version)
      })
    },
    complete() {
      this.visibleForm = false
      this.fetchList()
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  background-color: #f5f5f5;
  font-size: 15px;
  font-weight: 700;
  line-height: 35px;
  padding-left: 13px;

  button {
    margin-left: 10px;
  }
}
.btn-secondary {
  color: #6f6f6f;
  border-color: #6f6f6f;
  background-color: #fff;
  text-align: center;
}
.list {
  margin: 0;
  padding: 0 10px;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  span {
    display: block;
    text-align: center;
    line-height: 30px;
  }
  li {
    width: 60px;
    text-align: center;
    padding: 10px 0;
  }
}
</style>
